import React from 'react';

import { Page } from '@nearst/ui';
import { useShop } from '@services/ShopProvider';
import InventoryViewer from './InventoryViewer';

const Inventory = () => {
	const { shop } = useShop();

	return (
		<>
			<Page.Header>
				<h1>Manage items</h1>
				<p>Customize images, descriptions and channel visibility per product.</p>
				{shop.quantityBuffer > 0 && (
					<p>
						A quantity buffer of <strong>{shop.quantityBuffer}</strong> is applied to this shop. The quantities shown reflect a
						reduction of {shop.quantityBuffer} from the actual stock count.
					</p>
				)}
			</Page.Header>
			<Page.Section>
				<InventoryViewer />
			</Page.Section>
		</>
	);
};

export default Inventory;
